<template>
  <div class="animated fadeIn">
        <b-card>
            <div slot="header">
                Maintenance Manual/Guidence Form
              <div class="card-header-actions">
                <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()">
                  <i class="fa fa-save"></i> Save
                </button>
                <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
              </div>
            </div>
              <b-row>
                <b-col lg="7">
                    <b-row>
                      <b-col cols="6">
                        <b-input-group >
                          <b-input-group-prepend><label>Document No.</label></b-input-group-prepend>
                          <b-form-input v-model="model.referDoc" :state="!$v.model.referDoc.$error"></b-form-input>
                        </b-input-group>
                      </b-col>
                    </b-row>
                    <b-input-group >
                        <b-input-group-prepend><label>Maintenance Name</label></b-input-group-prepend>
                        <b-form-input v-model="model.inspectName" :state="!$v.model.inspectName.$error" ></b-form-input>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Work/Task Detail</label></b-input-group-prepend>
                        <b-form-textarea :rows="3" :max-rows="10" v-model="model.inspectDetail" :state="!$v.model.inspectDetail.$error" ></b-form-textarea>
                    </b-input-group>
                    <b-row>
                      <b-col cols="5">
                          <b-input-group >
                              <b-input-group-prepend><label>Repetitif Interval</label></b-input-group-prepend>
                              <b-form-input v-model="model.intervalCal" type="number"  :state="!$v.model.intervalCal.$error"></b-form-input>
                              <b-input-group-append> <span class="input-group-text">DAYS</span></b-input-group-append>
                          </b-input-group>
                      </b-col>
                      <b-col cols="7">
                          <b-input-group >
                              <b-input-group-prepend><span class="pt-2 mr-1">Repetitif in OdoMeter</span></b-input-group-prepend>
                              <b-form-input v-model="model.intervalUom" type="number" ></b-form-input>
                              <b-form-input v-model="model.intervalUomCode" placeholder="KM or HOUR or CYCLE" class="ml-1" ></b-form-input>
                          </b-input-group>
                      </b-col>
                    </b-row>
                </b-col>
                <b-col lg="5">
                  <b-input-group >
                    <b-input-group-prepend><label>Asset Category</label></b-input-group-prepend>
                    <b-form-select v-model="model.assetCatgId" :plain="true" :options="categories" :state="!$v.model.assetCatgId.$error"></b-form-select>
                  </b-input-group>
                  <b-input-group >
                    <b-input-group-prepend><label>Model/Type/Series</label></b-input-group-prepend>
                    <b-form-input v-model="model.assetModel" placeholder="Model/Type/Series"></b-form-input>
                  </b-input-group>
                  <b-input-group >
                    <b-input-group-prepend><label>Component/Part &nbsp;</label></b-input-group-prepend>
                    <b-form-input v-model="model.assetPart" placeholder="Body/Engine/Electronic" v-b-tooltip.hover title="Leave blank for WHOLE ASSET'S PART"></b-form-input>
                  </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Estimate Cost</label></b-input-group-prepend>
                        <b-input-group-prepend> <span class="input-group-text" style="width:80px !important;">{{uanguser}}</span></b-input-group-prepend>
                      <my-number class="form-control text-right mr-5" separator="," v-model="model.costEstimate" :precision="2"></my-number>
                    </b-input-group>
                </b-col>
              </b-row>

              <b-card title="Applicable to Fixed Asset">
                <b-table
                    class="mb-0"
                    ref="tblGroup"
                    outlined
                    striped hover small 
                    style="font-size:smaller;"
                    :items="asset.list"
                    :fields="asset.fields"
                    :current-page="asset.page"
                    :per-page="asset.limit"
                  >
                      <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                      </template>
                      <template v-slot:cell(tanggal)="data">
                        <span v-if="(data.item.tanggal)">{{data.item.tanggal| moment('D-MMM-YY')}}</span>
                      </template>
                      <template v-slot:cell(uomValue)="data">
                        <span v-if="(data.item.uomValue)">{{data.item.uomValue}} {{data.item.uomCode}} </span>
                      </template>
    
                      <template v-slot:cell(action)="data">
                        <div class="text-center">
                        <a href="javascript:void(0)" class="text-danger" @click="delAsset(data.index)">
                          <i class="fa fa-trash"></i>
                        </a>
                        </div>
                    </template>
                  <template v-slot:row-details="row">
                    <b-card no-body class="row-details-form">
                        <b-row class="ml-5 mt-2 mr-3">
                            <b-col cols="6">
                              <b-input-group>
                                  <b-input-group-prepend><label>Fixed Asset</label></b-input-group-prepend>
                                  <b-form-input v-model="assetObj.asetid" :state="!$v.assetObj.asetkey.$error" readonly class="mr-1" ></b-form-input>  
                                  <b-form-input v-model="assetObj.asdesc" :state="!$v.assetObj.asetkey.$error" readonly style="width:45% !important;"></b-form-input>                                        
                                  <b-input-group-append>
                                  <b-btn text="Button" @click="lkuFixedAssetShow=true" >
                                      <i class="fa fa-search"></i>
                                  </b-btn>
                                  </b-input-group-append>
                              </b-input-group>
                                <b-row>
                                  <b-col lg="6" >
                                    <b-input-group >
                                        <b-input-group-prepend><label>Group/Category</label></b-input-group-prepend>
                                        <b-form-input v-model="assetObj.catgname" readonly></b-form-input>                                        
                                    </b-input-group>
                                  </b-col>
                                  <b-col lg="6">                            
                                    <b-input-group >
                                        <b-input-group-prepend><label>Model/type/Series</label></b-input-group-prepend>
                                        <b-form-input v-model="assetObj.asmodel" readonly></b-form-input>
                                    </b-input-group>
                                  </b-col>
                                </b-row>
                                <b-row>
                                  <b-col lg="6" >
                                    <b-input-group >
                                        <b-input-group-prepend><label>Serial Number</label></b-input-group-prepend>
                                        <b-form-input disabled v-model="assetObj.asserial" readonly></b-form-input>                                        
                                    </b-input-group>
                                  </b-col>
                                  <b-col lg="6" >
                                    <b-input-group >
                                        <b-input-group-prepend><label>Usage Date</label></b-input-group-prepend>
                                        <b-form-input disabled v-model="assetObj.asdatuse" type="date"  readonly></b-form-input>                                        
                                    </b-input-group>
                                  </b-col>
                                </b-row>

                            </b-col>
                            <b-col cols="6">
                                <b-input-group >
                                    <b-input-group-prepend><label>Last Maintenance Date</label></b-input-group-prepend>
                                    <b-form-input v-model="assetObj.tanggal" type="date" :state="!$v.assetObj.tanggal.$error"></b-form-input>                                        
                                    <b-input-group-prepend><span class="input-group-text"> or firsttime usage date</span></b-input-group-prepend>
                                </b-input-group>
                                <b-input-group >
                                    <b-input-group-prepend><label>Last Recorded OdoMeter</label></b-input-group-prepend>
                                    <b-form-input v-model="assetObj.uomValue" type="number" placeholder="current OdoMeter" ></b-form-input>
                                    <b-form-input v-model="assetObj.intervalUomCode" class="ml-1" placeholder="KM or Hour or Cycle"></b-form-input>
                                </b-input-group>
                            </b-col>
                        </b-row>
                        <b-row class="justify-content-center mb-2">
                            <b-button class="btn btn-info mr-1" @click="saveAsset()">Save</b-button>
                            <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Close</b-button>
                        </b-row>
                    </b-card>
                  </template>                        

                </b-table>
                <b-row>
                  <b-col cols="5">
                    <b-row>
                      <b-button size="sm" class="btn btn-primary ml-3" @click="addAsset" >Add Asset</b-button>                          
                      <div class="ml-2">
                        Showing
                        {{(asset.page - 1) * asset.limit + 1}}
                        to
                        {{asset.page * asset.limit}}
                        of
                        {{asset.total}}
                        entries
                      </div>    
                    </b-row>                    
                  </b-col>
                  <b-col cols="3">            
                      <b-row class="ml-2 mt-2">
                        <span class="pt-1 pr-2">Limit per page</span>
                        <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="asset.limit"  size="sm" style="width:80px !important;"/>
                      </b-row>
                  </b-col>
                  <b-col cols="4">            
                    <b-pagination
                      align="right"
                      :total-rows="asset.total"
                      :per-page="asset.limit"
                      v-model="asset.page"
                    ></b-pagination>
                  </b-col>
                </b-row>
              </b-card>

            <b-row class="justify-content-center mb-2">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()"><i class="fa fa-save"></i> Save</button>
                <b-button class="btn btn-primary mr-1" @click.stop="close()" > <i class="fa fa-close"></i> Close</b-button>
            </b-row>
    </b-card>
        <b-modal v-model="lkuFixedAssetShow" size="lg" :hide-footer="true" title="List of Fixed Asset" :centered="true">
            <lku-fixedasset @click="onSelectLkuFixedAsset" :formdata="lkuFixedAssetData"></lku-fixedasset>
        </b-modal>        

  </div>
</template>

<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 120px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import moment from 'moment';
import myNumber from "../../components/my-number";
import mm from "../../apis/maintenguide";
// import lkuFixedasset from "../lookup/lkuFixedAsset";
import lkuFixedasset from "../lookup/lkuFassetLazzy";
import { validationMixin } from "vuelidate";
import { required, minValue, maxLength, numeric } from "vuelidate/lib/validators";
import toastr from "mini-toastr";
toastr.init();

export default {   
  components:{myNumber, lkuFixedasset},
  mixins: [validationMixin],
  validations: {
    model: {
        referDoc: { required },
        inspectName: { required },
        inspectDetail: { required },
        intervalCal: { required },
        assetCatgId: { required },
        assetCatgName: { required },
    },
    assetObj: {
        asetkey: { required },
        tanggal: { required },
    },
  }, 
  data () {
    return {
        lkuFixedAssetShow: false,
        lkuFixedAssetData:{},
        saveEnabled:true,
        model:{inspectName:'',inspectDetail:'', intervalCal:'', assetCatgId:'', assetCatgName:''},
        assetObj:{asetkey:'', tanggal:'', inspMstrKey:''},
        asset: {
            list: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                  key: "asetid",
                  thStyle: "width:100px",
                  label: "FA Number",
                  sortable: true
                },
                {
                  key: "asdesc",
                  label: "FA Name/Description",
                },
                {
                  key: "asmodel",
                  label: "Model/Type/Series",
                  sortable: true
                },
                {
                  key: "asserial",
                  label: "S/N",
                  sortable: true
                },
                {
                  key: "catgname",
                  label: "Category/Group",
                  thStyle: "width:200px",
                  sortable: true
                },
                {
                  key: "tanggal",
                  thStyle: "width:90px",
                  label: "Last Maintenance",
                  sortable: true
                },
                {
                  key: "uomValue",
                  label: "OdoMeter",
                  thStyle: "width:80px",
                  sortable: true
                },
                {
                  key: "action",
                  label: "action",
                  thClass: "text-center",
                  tdClass: "text-center",
                },

            ],
            page: 1,
            limit: 6,
            total: 0,
        },
        uanguser: this.$store.state.user.matauang,
      categories:[]
    }
  },
  computed: {
      invalidModel() {
        this.$v.model.$touch();
        return this.$v.model.$invalid;
      },
      invalidAssetObj() {
        this.$v.assetObj.$touch();
        return this.$v.assetObj.$invalid;
      },
      catgid() {
        return this.model.assetCatgId;
      },
  },
  watch:{
    catgid: function(newval){
      const catg = this.categories.find(c => c.value == newval)
      if (catg) {
        this.model.assetCatgName=catg.text;
      }
    }
  },
  created: async function(){
      const [a] = await Promise.all([mm.category()]) ;
        // this.categories = a.reduce((newArr,item) =>{
        //     newArr.push(item);
        //     return newArr;
        // },[{ value: '', text: '--- ALL ---'}]);
      this.categories= a;
      if (this.$route.params.inspMstrKey)  {
          toastr.info('Loading  Detail Maintenance Manual, please wait')
          try {
            const data = await mm.detail(this.$route.params);  
            const row = data[0];
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.asset.list = data[1];
        this.asset.total=this.asset.list.length;
            this.$forceUpdate();
            toastr.clear;
          } catch (error) {
              console.log('error : ', error);
              toastr.error(JSON.stringify(error), "ERROR MESSAGE",10000);                              
          }
      } 

  },
  methods:{
    onSelectLkuFixedAsset(_selected) {
      const mmAda = this.asset.list.find(c => c.asetkey == _selected.asetkey)
      if (mmAda) {
        toastr.warn(`${_selected.asetid} | ${_selected.asdesc} already Applied`);
      } else {
        this.assetObj.asetkey = _selected.selected.asetkey;
        this.assetObj.asetid = _selected.selected.asetid;
        this.assetObj.asdesc = _selected.selected.asdesc;
        this.assetObj.catgname = _selected.selected.catgname;
        this.assetObj.catgid = _selected.selected.catgid;
        this.assetObj.asmodel = _selected.selected.asmodel;
        this.model.tanggal = moment(_selected.selected.asdatuse || _selected.selected.asdatacq).format('YYYY-MM-DD');
        this.lkuFixedAssetData=_selected;
        this.lkuFixedAssetShow=false;
      }
    },
    addAsset : function () {
        const obj={_showDetails:true};
        this.asset.selected = obj;
        for (var key in this.assetObj) {
            this.assetObj[key] = '';
        }
        this.asset.list.push(obj);
        this.asset.total=this.asset.list.length;
    },
    delAsset: function (index) {
        if (index > -1) {
          // this.asset.list.splice(index, 1);
            const posisi = (this.asset.page-1)*this.asset.limit;
            this.asset.list.splice(posisi+index, 1);
        }
        this.asset.total=this.asset.list.length;
    },
    saveAsset: function(callback){
        if (this.invalidAssetObj) {
            console.log('validation contact : ', this.$v.assetObj);
            console.log('selected contact : ',this.assetObj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
            for (var key in this.assetObj) {
                this.asset.selected[key] = this.assetObj[key];
            }
            this.asset.selected._showDetails=false;
            if (callback) callback();
        }
    },    
    save: async function(){
        if (!this.saveEnabled) {
            return;
        }
        this.saveEnabled=false;            
        if (this.invalidModel) {
            console.log('validation  : ', this.$v.model);
            console.log('model : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;            
       } else {
            try {
              const data={};
              for (var key in this.model) {
                  data[key] = this.model[key];
              }
              data.assets = this.asset.list.reduce((newArr, item) => {
                  if ((item.asetkey || '') != '')
                  {
                    item.tanggal= moment(item.tanggal).format('YYYY-MM-DD');
                      newArr.push(item);
                  }
                  return newArr;
              }, []);
              await mm.save(data);
              this.close();
            } catch (error) {
                this.saveEnabled=true;            
                if (error.message) {
                    toastr.error(error.message, "ERROR MESSAGE",10000);
                } else {
                    toastr.error(JSON.stringify(error), "ERROR MESSAGE",10000);
                }              
            }
        }
    },
    close(){
      if ((this.$store.state.prevRoute.name) && !this.$store.state.prevRoute.name.includes('maintmanualfrm'))  {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        router.push('home');
      }
    },    

  }
}
</script>